import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './InfoBar.scss';

export default class InfoBar extends Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
			.isRequired,
	};

	render() {
		return (
			<div className="row InfoBar">
				{React.Children.toArray(this.props.children)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/InfoBar/index.js